export default {
    translation: {
    LOGIN:"Login"
    }
}